var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ValidationObserver", {
    ref: "registerOrganisationObserver",
    attrs: { slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var invalid = ref.invalid
          var errors = ref.errors
          return [
            _c("text-label-row", {
              attrs: {
                title: "Registration.FullName",
                id: "registrarName",
                labelClass:
                  "col-12 col-md-4 col-lg-3 col-form-label pb-0 pb-md-2",
                valueClass: "col-12 col-md-8 col-lg-9 pt-0 pt-md-2"
              },
              model: {
                value: _vm.fullName,
                callback: function($$v) {
                  _vm.fullName = $$v
                },
                expression: "fullName"
              }
            }),
            _vm._v(" "),
            _c("text-label-row", {
              attrs: {
                title: "Registration.Ssn",
                id: "registrarSsn",
                labelClass:
                  "col-12 col-md-4 col-lg-3 col-form-label pb-0 pb-md-2",
                valueClass: "col-12 col-md-8 col-lg-9 pt-0 pt-md-2"
              },
              model: {
                value: _vm.registration.registrarSsn,
                callback: function($$v) {
                  _vm.$set(_vm.registration, "registrarSsn", $$v)
                },
                expression: "registration.registrarSsn"
              }
            }),
            _vm._v(" "),
            _c("text-input-row", {
              attrs: {
                title: "Registration.Email",
                id: "registrarEmail",
                required: true,
                rules: _vm.emailRules,
                providerMode: "aggressive",
                providerName: "email"
              },
              model: {
                value: _vm.registration.registrarEmail,
                callback: function($$v) {
                  _vm.$set(_vm.registration, "registrarEmail", $$v)
                },
                expression: "registration.registrarEmail"
              }
            }),
            _vm._v(" "),
            _c("text-input-row", {
              attrs: {
                title: "Registration.Password",
                id: "newPassword",
                type: "password",
                required: true,
                rules: { password: true },
                providerName: "newPassword",
                providerMode: "aggressive"
              },
              model: {
                value: _vm.registration.password,
                callback: function($$v) {
                  _vm.$set(_vm.registration, "password", $$v)
                },
                expression: "registration.password"
              }
            }),
            _vm._v(" "),
            _c("text-input-row", {
              attrs: {
                title: "Registration.ConfirmPassword",
                id: "confirmPassword",
                type: "password",
                required: true,
                rules: { passwordConfirm: "@newPassword", password: true },
                providerMode: "aggressive",
                providerName: "confirmPassword"
              },
              model: {
                value: _vm.confirmPassword,
                callback: function($$v) {
                  _vm.confirmPassword = $$v
                },
                expression: "confirmPassword"
              }
            }),
            _vm._v(" "),
            _c("text-input-row", {
              attrs: {
                title: "Registration.OrganisationName",
                id: "name",
                required: true,
                rules: { organisationName: true },
                providerMode: "aggressive",
                providerName: "organisationName",
                maxLength: 100
              },
              model: {
                value: _vm.registration.name,
                callback: function($$v) {
                  _vm.$set(_vm.registration, "name", $$v)
                },
                expression: "registration.name"
              }
            }),
            _vm._v(" "),
            _c("text-input-row", {
              attrs: {
                title: "Registration.BusinessId",
                id: "businessId",
                required: true,
                rules: { businessId: true, businessIdExists: true },
                providerMode: "aggressive",
                providerName: "businessId"
              },
              model: {
                value: _vm.registration.businessId,
                callback: function($$v) {
                  _vm.$set(_vm.registration, "businessId", $$v)
                },
                expression: "registration.businessId"
              }
            }),
            _vm._v(" "),
            _c("year-input-row", {
              attrs: {
                id: "foundingYear",
                title: "Registration.FoundingYear",
                required: true,
                minValue: 1000,
                maxValue: _vm.currentYear
              },
              model: {
                value: _vm.registration.foundingYear,
                callback: function($$v) {
                  _vm.$set(_vm.registration, "foundingYear", _vm._n($$v))
                },
                expression: "registration.foundingYear"
              }
            }),
            _vm._v(" "),
            _c("text-input-row", {
              attrs: {
                title: "Registration.OrganisationEmail",
                id: "organisationEmail",
                required: true,
                rules: _vm.organisationEmailRules,
                providerMode: "aggressive",
                providerName: "email"
              },
              model: {
                value: _vm.registration.OrganisationEmail,
                callback: function($$v) {
                  _vm.$set(_vm.registration, "OrganisationEmail", $$v)
                },
                expression: "registration.OrganisationEmail"
              }
            }),
            _vm._v(" "),
            _c("radio-button-option-row", {
              attrs: {
                title: "Organisation.Language.Title",
                labelColWidth: "col-12 col-md-4 col-lg-3",
                required: true,
                options: _vm.languageOptions,
                showValidationErrorText: true
              },
              model: {
                value: _vm.registration.language,
                callback: function($$v) {
                  _vm.$set(_vm.registration, "language", $$v)
                },
                expression: "registration.language"
              }
            }),
            _vm._v(" "),
            _c("attachments", { attrs: { attachments: _vm.attachments } }),
            _vm._v(" "),
            _c("radio-button-row", {
              attrs: {
                title: "Registration.Procuration",
                id: "hasProcuration",
                truthyOptionTitle: "Registration.HasProcuration",
                falsyOptionTitle: "Registration.NoProcuration",
                required: true,
                noLeftPadding: true
              },
              model: {
                value: _vm.registration.procuration,
                callback: function($$v) {
                  _vm.$set(_vm.registration, "procuration", $$v)
                },
                expression: "registration.procuration"
              }
            }),
            _vm._v(" "),
            _c("check-box-boolean-with-button", {
              attrs: {
                title: "TermsOfUse.AcceptTermsOfUse",
                id: "acceptTerms",
                btnid: "showTermsBtn",
                label: "TermsOfUse.AcceptTermsOfUse",
                required: true,
                disabled: _vm.approveTermsDisabled,
                btndisabled: _vm.processing,
                "aria-label": _vm.$t("TermsOfUse.ShowTermsButtonBelow"),
                instructionKey: "TermsOfUse.AcceptTermsOfUse_Instructions"
              },
              on: { btnClick: _vm.showTerms },
              model: {
                value: _vm.registration.electronicCommunication,
                callback: function($$v) {
                  _vm.$set(_vm.registration, "electronicCommunication", $$v)
                },
                expression: "registration.electronicCommunication"
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "mt-3 mb-5" }, [
              _c(
                "div",
                { staticClass: "d-inline-block", attrs: { tabindex: "0" } },
                [
                  _vm.isSendBtnDisabled(!invalid)
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-default mb-1 login-page-button",
                          attrs: {
                            type: "button",
                            disabled: "",
                            "aria-disabled": true,
                            "aria-describedby": "mandatory"
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("Registration.Btn_Continue")) +
                              "\n        "
                          ),
                          _c("i", { staticClass: "fas fa-chevron-right" })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isSendBtnDisabled(!invalid)
                    ? _c(
                        "button",
                        {
                          staticClass:
                            "btn btn-secondary mb-1 login-page-button",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.save()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.$t("Registration.Btn_Continue")) +
                              "\n        "
                          ),
                          _c("i", { staticClass: "fas fa-chevron-right" })
                        ]
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _vm.isSendBtnDisabled(!invalid) && !_vm.loading
                ? _c(
                    "p",
                    {
                      staticClass: "warning-text d-inline ml-1 mt-2",
                      attrs: { id: "mandatory" }
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(
                            _vm.$t("Registration.FillAllMandatoryFields")
                          ) +
                          "\n      "
                      ),
                      _c("span", { staticClass: "sr-only" }, [
                        _vm._v(_vm._s(_vm.errorMessages(errors)))
                      ])
                    ]
                  )
                : _vm._e()
            ])
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }